import { motion } from "framer-motion";
import ScrollFadeIn from "./Scrollfadein";
import { skillIcons } from "./Data";
import { useIsMobile } from "./Useismobile";

export default function Skills({ theme }) {
  const { muted, border, darkMode } = theme;
  const isMobile = useIsMobile();

  return (
    <section style={{ padding: isMobile ? "40px 20px" : "60px 40px", maxWidth: 1200, margin: "0 auto" }}>
      <ScrollFadeIn>
        <div style={{ height: 1, background: border, marginBottom: 32 }} />
        <span style={{ fontSize: 10, letterSpacing: "0.2em", color: muted }}>
          STACK & TOOLS
        </span>
      </ScrollFadeIn>

      <ScrollFadeIn delay={0.1}>
        <div style={{
          display: "grid",
          gridTemplateColumns: isMobile
            ? "repeat(4, 1fr)"
            : "repeat(auto-fill, minmax(96px, 1fr))",
          gap: isMobile ? 2 : 4,
          marginTop: 28,
        }}>
          {Object.entries(skillIcons).map(([skill, url], i) => (
            <motion.div
              key={skill}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.04, duration: 0.4 }}
              whileHover={!isMobile ? { y: -4 } : {}}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 6,
                padding: isMobile ? "14px 6px" : "18px 8px",
                borderRadius: 12,
                cursor: "default",
                transition: "background 0.2s",
              }}
              onMouseEnter={e => !isMobile && (e.currentTarget.style.background = darkMode ? "#111" : "#f0f0ec")}
              onMouseLeave={e => !isMobile && (e.currentTarget.style.background = "transparent")}
            >
              <img
                src={url}
                alt={skill}
                style={{ width: isMobile ? 28 : 34, height: isMobile ? 28 : 34, objectFit: "contain" }}
                loading="lazy"
                draggable={false}
              />
              <span style={{
                fontSize: isMobile ? 7 : 9,
                letterSpacing: "0.08em",
                color: muted,
                textAlign: "center",
                lineHeight: 1.3,
              }}>
                {skill.toUpperCase()}
              </span>
            </motion.div>
          ))}
        </div>
      </ScrollFadeIn>
    </section>
  );
}